import React from "react";
import { motion } from "framer-motion";

export default function Reveal({ children, delay = 0, y = 30, className = "", as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: [0.19, 1, 0.22, 1], delay }}
      className={className}
    >
      {children}
    </MotionTag>
  );
}
